// Importado primeiro em main.tsx: instala a telemetria antes do cliente do servidor ser criado,
// para que as falhas de requisição dele também passem pelo capturador.
// Não altera APIs do DOM: erros desconhecidos seguem para o ErrorBoundary e são só registrados.
import { installClientTelemetry } from "./clientTelemetry";

try {
  installClientTelemetry({
    backendBase: String(import.meta.env.VITE_SUPABASE_URL || "").replace(/\/+$/, ""),
    apiKey: String(import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY || ""),
    enabled: import.meta.env.MODE !== "test",
  });
} catch { /* nunca bloqueia o app */ }
